import { gql } from '@apollo/client';

export const GET_NEXT_GROUP_CODE = gql`
  query GetNextGroupCode {
    nextGroupCode: getNextGroupCode
  }
`;
